var Authorization = '';
var newsPageHandle = 'news';
var productLimit  = [];
var url = window.location.href,
    parts = url.split("/"),
    last_part = parts[parts.length-1];

var totalPage = '15';

if(last_part == ''){
    last_part = parts[parts.length-2];
}
var flag=0;

var hostName = window.location.hostname;
var current_locale_code = $('html').attr('lang');
if(current_locale_code == 'de'){
  var current_locale_code = 'de_CH';
  var site_url = '';
  var filter_locale = '';
}else{
  var site_url = '//'+hostName;
  var filter_locale = '&filter[locale]='+current_locale_code;
}

//console.log('site_url',site_url)

var collectionHandle = [];
var ajaxComplete = false;

$(document).ready(function(){
  var slidetoshow=7;
  
  if(getParameterByName('page') == null){
    var pageno = 1;
  }else{
    var pageno = getParameterByName('page')
  }
  if(getParameterByName('category') == null){
    var cat = '';
  }else{
    var cat = getParameterByName('category');
  }
  if(getParameterByName('player') == null){
    var plyr = '';
  }else{
    var plyr = getParameterByName('player');
  }
  
  if(last_part.indexOf('news?page') != -1){
    var q = "?page[number]="+pageno+"&page[size]="+totalPage+"&sort=-publishDate&filter[isActive]=1";
  }
  else{
    if(last_part == 'news'){
      var q = "?page[number]="+pageno+"&page[size]="+totalPage+"&sort=-publishDate&filter[isActive]=1";
    }else{
      if(getParameterByName('category') == null){
        if(plyr != ''){
          var q = "?page[number]="+pageno+"&page[size]="+totalPage+"&sort=-publishDate&filter[isActive]=1&filter[b2cId]="+plyr;
        }else{
          if(last_part.indexOf('?') != -1){
            last_part = last_part.split('?')[0];
          }
          var q = '/'+last_part;
          if(!$.isNumeric(last_part)){
            var q = '?filter[urlHandle]='+last_part;
          }
          //       var q = '/3';
          flag++;
          filter_locale = '';
          $('.news-list-wrapper').addClass('hidden');
        }
      }
      else{
        var q = "?page[number]="+pageno+"&page[size]="+totalPage+"&sort=-publishDate&filter[isActive]=1&filter[newsCategoryId]="+getParameterByName('category');
      }
    }
  }

  // console.log(q);
  
  var settings = {
    "url": "/a/api-request/aico/theme/news"+q+filter_locale+"&filter[isPreview]=true",
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Authorization": Authorization,
      "Accept": "application/vnd.api+json",
    }
  };
  $.ajax(settings).done(function (response) {
    //console.log(response);
    
    var totalData = response.data.length;
    var html = '';
     
    if(typeof totalData == 'undefined' || flag > 0)
    {
      
    //console.log(response.data.length);
    if(response.data.length == 0){
      // $('.preloading').remove();
      $('#news-container').addClass('news-details-wrapper');
      $('body').addClass('news-details');
      $('#news-details-container').removeClass('hidden');
      html += '<h3>News not available</h3>';
      
    }
      if(typeof totalData == 'undefined'){
        var newsCat = response.data.attributes.newsCategory;
      }else{
        var newsCat = response.data[0].attributes.newsCategory;
      }
      
      var nq = '';
      if(newsCat != null){
        nq = '&filter[newsCategoryId]='+newsCat.translations[0].id;
      }
      
      $('.news-page-container').remove();
      $('.page-title').remove();
      $('.feature_divider').remove();
      
      // var settings = {
      //   "url": "/a/api-request/aico/theme/news?page[number]=1&page[size]=4&filter[isActive]=1&sort=-publishDate"+nq,
      //   "method": "GET",
      //   "timeout": 0,
      //   "headers": {
      //     "Authorization": Authorization,
      //     "Accept": "application/vnd.api+json"
      //   },
      // };

      // $.ajax(settings).done(function (responsen) {
      // var totalNewsData = responsen.data.length; 

      var cole=0;
    
      $('#news-container').addClass('news-details-wrapper');
      $('body').addClass('news-details');
      $('#news-details-container').removeClass('hidden');
        if(typeof totalData == 'undefined'){
          var data = response.data.attributes;
        }else{
          var data = response.data[0].attributes;
        }

        var img = data.optimizedImage;
        if(data.optimizedImage == null){
          img = data.image;
        }else if(data.image == null){
          img = '';
        }

        var translations = data.translations;       
        if(translations.length>0){
          for(var t=0;t<translations.length;t++){
            var translation = translations[t];            
            if(translation.locale == current_locale_code ){              
              title = jQuery.trim(translation.name);
            }            
          }
        }

       
        if(typeof title == 'undefined'){          
           title = jQuery.trim(data.name);
        }
      
        $('title').text(title+" | Mediconsult Schweiz");
      
        html += '<div class="news-content-wrapper">';
        html += '<div class="page-width">';
             
        html += '<div class="title-wrapper">';
        html += '<h2>'+title+'</h2>';
        html += '</div>';
        html += '<div class="tag-wrapper">';
          html += '<div class="tag-inner">';
            html +='<div class="news-category">';
          if(data.newsCategory != null ){
            var cat = data.newsCategory;
            var catName = cat.translations[0].webName;
            var catLink = site_url+'/pages/news?category='+cat.id;
            
            html += '<a href="'+catLink+'" class="news-cat">'+catName+', </a>';
          }
              html += '</div>';
          if(data.publishDate != null ){
            html += '<span class="news-date">'+formatDate(data.publishDate)+', </span>';
          }
          if(data.author != null ){
            html += '<span class="news-author">'+data.author+'</span>';
          }
          html += '</div>';
        html += '</div>';
         
        html += '<div class="description-wrapper">';
        var showcontentBuilder = 'false';
        if(data.contentBuilder != null){
          var rows = data.contentBuilder.rows;
          if(rows.length > 0){
            showcontentBuilder = 'true';
            for(var row = 0; row<rows.length; row++ ){
              var columns = rows[row].columns;
              var isFullWidth = '';
              if(rows[row].order != null){
                var rowOrder = rows[row].order;
              }else{
                var rowOrder = '0';
              }
              if(rows[row].isFullWidth == 1){
                isFullWidth = 'fullwidth';
              }
              if(columns.length > 0){
                var totalColumns = columns.length;
              }else{
                var totalColumns = 0;
              }
              html += '<div class="content-row row__'+(row+1)+' '+isFullWidth+' total-columns-'+totalColumns+'" style="order:'+rowOrder+'">';
                if(columns.length > 0){
                  for(var column = 0; column < columns.length; column++){
                    var contentContainer  = columns[column].contentContainer;
                    html += '<div class="content-column column__'+(column+1)+'">';
                      if(contentContainer != null){
                        var contents = contentContainer.contents;
                        if(contents.length > 0){
                          for(var content = 0; content < contents.length; content++ ){
                            var isSplit = contents[content].isSplit;;
                            var contentData = contents[content].contentData;
                            var contentType = contents[content].type;
                            if(contents[content].containerOrder != null){
                              var containerOrder = contents[content].containerOrder;
                            }else{
                              var containerOrder = '0';
                            }
                            
                            
                            if(contentData != null){
                              html += '<div class="content content__'+(content+1)+'" style="order:'+containerOrder+'">';

                              var translations = contentData.translations;

                              // Language translation forloop
                              for(var t=0; t<translations.length; t++){
                                var translation = translations[t];
                                if(translation.locale == current_locale_code){

                                 // console.log(translation.locale,'--',current_locale_code);
                                  if(contentType == 'HEADING'){
                                    if(contentData.textColor != ''){
                                      var textColor = 'color:'+contentData.textColor;
                                    }else{ var textColor = '';}
                                    html += '<div class="content-type-title">';
                                      html += '<'+contentData.titleSize+' style="'+textColor+'">';
                                        html += translation.title;
                                      html += '</'+contentData.titleSize+'>';
                                      if(translation.description != ''){
                                        html += '<p>'+translation.description+'</p>';
                                      }
                                    html += '</div>';
                                  } // end if contentType HEADING


                                   if(contentType == 'TITLE'){
                                    if(contentData.textColor != ''){
                                      var textColor = 'color:'+contentData.titleColor;
                                    }else{ var textColor = '';}
                                    html += '<div class="content-type-title">';
                                      html += '<'+contentData.size+' style="'+textColor+'">';
                                        html += translation.title;
                                      html += '</'+contentData.size+'>';
                                      
                                    html += '</div>';
                                  } // end if contentType title


                                  if(contentType == 'TEXT'){
                                    var description = $.trim(translation.text);
                                    if(translation.optimizedPicture != null){
                                      var picture = translation.optimizedPicture;
                                    } else if(translation.picture != null){
                                      var picture = translation.picture;
                                    } else {
                                      var picture = '';
                                    }
                                    
                                    html += '<div class="content-type-text">';
                                    
                                    if(picture == ''){
                                      if(translation.title != null && translation.title!= ''){
                                        if(contentData.textColor != '' && contentData.textColor != null){
                                          var textColor = 'color:'+contentData.textColor;
                                        }else{ var textColor = '';}
                                        if(contentData.fontSize != '' && contentData.fontSize != null ){
                                          var textSize = 'font-size:'+contentData.fontSize+'px;';
                                        }else{ var textSize = '' }
                                        
                                        html += '<'+contentData.titleSize+' style="'+textSize+textColor+'">'+translation.title+'</'+contentData.titleSize+'>';
                                      }
                                    }
                                      if(description != null ){
                                         if(contentData.fontSize != '' && contentData.fontSize != null ){
                                          var textSize = 'font-size:'+contentData.fontSize+'px;';
                                        }else{ var textSize = '' }
                                        if(contentData.fontFamily != '' && contentData.fontFamily != null ){
                                          var textFontFamily = 'font-family:'+contentData.fontFamily+'px;';
                                        }else{ var textFontFamily = '' }
                                        html += '<div style="'+textSize+textFontFamily+'">'+description+'</div>';
                                      }
                                     
                                      if(picture != ''){
                                        html += '<div class="image-container image-width--'+contentData.pictureSize+' image-text--'+contentData.picturePosition+'" style="text-align:'+contentData.picturePosition+'">';
                                          html += '<div class="image-container-inner">';
                                          html += '<img data-src="'+picture+'" alt="" class="lazyload" loading="lazy">';
                                          if(translation.pictureLabel != null && translation.pictureLabel != ''){
                                            html += '<span class="image-caption">'+translation.pictureLabel+'</span>';
                                          }
                                          html += '</div>';
                                        html += '</div>';
                                      }
                                    html += '</div>';
                                  } // end if contentType text

                                  if(contentType == 'BULLET'){
                                    html += '<div class="content-type-bullet">';
                                      if(translation.title != null && translation.title != '' ){
                                        html += '<'+contentData.titleSize+'>'+translation.title+'</'+contentData.titleSize+'>';
                                      }
                                      if(translation.text != null && translation.text != ''){
                                        html += '<p>'+translation.text+'</p>';
                                      }
                                      if(contentData.fontSize != null){
                                        var fontSize = 'font-size:'+contentData.fontSize+'px';
                                      }else{ fontSize = '';}
                                      if(contentData.bulletBullets.length > 0){
                                        html += '<ul style="'+fontSize+'">';
                                        for(var b = 0; b<contentData.bulletBullets.length; b++){
                                          var translations = contentData.bulletBullets[b].translations;
                                          if(translations.length > 0){
                                            for(var t = 0; t<translations.length; t++){
                                              var translation = contentData.bulletBullets[b].translations[t];
                                              if(translation.locale == current_locale_code){
                                                html +='<li>'+translation.text+'</li>';
                                              }
                                            }
                                          }
                                          
                                        }
                                        html += '</ul>';
                                      }
                                    html += '</div>';
                                  } // end if contentType Bullet

                                  if(contentType == 'TABLE'){
                                    html += '<div class="content-type-table">';
                                      html += '<'+contentData.titleSize+'>'+translation.title+'</'+contentData.titleSize+'>';
                                      html += '<p>'+translation.additionalText+'</p>';
      
                                      if(contentData.bulletBullets.length > 0){
                                        html += '<table class="table table-styled">';
                                        for(var b = 0; b<contentData.bulletBullets.length; b++){
                                          html += '<tr>';
                                          var translations = contentData.bulletBullets[b].translations;
                                          if(translations.length > 0){
                                            for(var t = 0; t<translations.length; t++){
                                              var translation = contentData.bulletBullets[b].translations[t];
                                              if(translation.locale == current_locale_code){
                                                html +='<td>'+translation.label+'</td>';
                                                html +='<td>'+translation.content+'</td>';
                                              }
                                            }
                                          }
                                          
                                          html += '</tr>';
                                        }
                                        html += '</table>';
                                      }
                                      
                                    html += '</div>';
                                  } // end if contentType TABLE

                                  if(contentType == 'HTML'){
                                   
                                    html += '<div class="content-type-html">';
                                      html += '<p>'+translation.text+'</p>';
                                    html += '</div>';
                                  } // end if contentType html
  
                                  if(contentType == 'LINK'){
                                  
                                    html += '<div class="content-type-link">';
                                    if(translation.title != '' && translation.title != null){
                                      if(contentData.fontSize != '' && contentData.fontSize != null ){
                                        var textSize = 'font-size:'+contentData.fontSize+'px;';
                                      }else{ var textSize = '' }
                                      
                                      html += '<h3 style="'+textSize+'">'+translation.title+'</h3>';
                                    }
                                    if(translation.linkText != '' && translation.linkText != null){                                 
                                        var btnLinkClass = '';
                                        if(contentData.isButtonLink == '1'){
                                          btnLinkClass = 'button button-link';
                                          html += '<style>.row__'+(row+1)+' .content__'+(content+1)+' .button-link{background-color: '+contentData.backgroundButtonColor+';color:'+contentData.textButtonColor+'}.row__'+(row+1)+' .content__'+(content+1)+' .button-link:hover{background-color:'+contentData.hoverColor+';}</style>';
                                        }                                
                                        html += '<a href="'+translation.link+'" class="'+btnLinkClass+'">';                                
                                        if(translation.linkText != ''){
                                            html += translation.linkText;
                                        }                                  
                                        html += '</a>';
                                    }
                                    if(translation.imageUrl != '' && translation.imageUrl != null){
      
                                      html += '<div class="image-container image-width--'+contentData.pictureSize+' image-text--'+contentData.picturePosition+'" style="text-align:'+contentData.picturePosition+'">';
                                        html += '<div class="image-container-inner">';
                                          html += '<a href="'+translation.link+'">';
                                            html += '<img data-src="'+translation.imageUrl+'" alt="" class="lazyload" loading="lazy">';
                                          html += '</a>';
                                        html += '</div>';
                                      html += '</div>';
                                      
                                       
                                    }
                                    html += '</div>';
                                  } // end if contentType link

                                  if(contentType == 'VIDEO'){

                                    var videourl = contentData.videoUrl;
                                    if (videourl == '' || videourl == null){
                                     var videourl = contentData.localVideoUrl;
                                    }
                                    
                                    if(videourl!='' && videourl != null ){
                                        var videoId = youtube_parser(videourl.trim());
                                     
                                        if(videoId!=false){
                                           html += '<div class="content-type-video">';
                                            html += '<iframe title="'+translation.title+'" src="https://www.youtube.be/embed/'+videoId+'?feature=oembed&amp;enablejsapi=1&amprel=0;" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
                                           html += '</div>';                                    
                                        } else {                                     
                                          html += '<div class="content-type-video">';
                                            html += '<video controls><source src="'+videourl+'" type="video/mp4"></iframe>';
                                          html += '</div>';                                   
                                        } 
                                    }
                                                                    
                                  } // end if contentType video

                                  if(contentType == 'CONTENT_CARD'){
                                    html += '<div class="content-type-content-card">';
                                      html += '<'+contentData.titleSize+'>';
                                        html += translation.title;
                                      html += '</'+contentData.titleSize+'>';
                                      if(translation.text != ''){
                                        html += '<p>'+translation.text+'</p>';
                                      }
                                      if(contentData.picture != '' && contentData.picture ){
                                        html += '<img data-src="'+contentData.picture+'" class="lazyload" loading="lazy">'
                                      }
                                    html += '</div>';
                                  } // end if contentType CONTENT_CARD

                                  if(contentType == 'CAROUSEL'){                                
                                    html += '<div class="content-type-carousel">';
                                    html += '<div id="news-media-wrapper" class="news-media-wrapper">';
                                    if(contentData.contentCarouselImages.length > 0){
                                      var album_image = contentData.contentCarouselImages;
                                      if(album_image.length > 9){
                                        slidetoshow = 9;
                                      }
                                      html += '<div class="news-slider slider-for">';
                                      for(var ai = 0; ai < album_image.length; ai++){
                                        html += '<div class="news-images">';
                                          html += '<img data-src="'+album_image[ai].picture+'" class="lazyload" alt="">';
                                        
                                          for(var coroa=0; coroa<album_image[ai].translations.length;coroa++){
                                            var translation = album_image[ai].translations[coroa];
                                            if(translation.locale == current_locale_code){
                                           
                                              if(translation.title != null ){
                                                html += '<span class="image-caption">'+translation.title+'</span>';
                                              }
                                              
                                            }
                                            
                                          }

                                          
                                        html += '</div>';
                                      }
                                      html += '</div>'; // end slider-for
                                      html += '<div class="news-thumbnail slider-nav">';
                    
                                        for(var ai = 0; ai < album_image.length; ai++){
                                          var imgSrc = '';
                                          
                                          if(album_image[ai].picture != null){
                                            imgSrc = album_image[ai].picture;
                                          }else{
                                            imgSrc = album_image[ai].picture;
                                          }
                                          html += '<div class="news-thumbnail-images">';
                                              html += '<img data-src="'+imgSrc+'" alt="" class="lazyload" width="150">';
                                          html += '</div>';
                                        }
                                        html += '</div>';
        
                                      html += '</div>';
                                    html += '</div>';
                                    } // end if contentType album
                                  }

                                  if(contentType == 'ALBUM'){
                                    html += '<div id="news-media-wrapper-1" class="news-media-wrapper">';
                                    
                                      var album_image = contentData.album.images;
                                      
                                      html += '<div class="news-slider slider-for">';
                                      
                                      if(album_image.length > 9){
                                        slidetoshow = 9;
                                      }
                                      
                                      for(var ai = 0; ai < album_image.length; ai++){
                                        var imgSrc = '';
                                        
                                        if(album_image[ai].optimizedImage != null){
                                          imgSrc = album_image[ai].optimizedImage;
                                        }else{
                                          imgSrc = album_image[ai].url;
                                        }
                                        
                                        html += '<div class="news-images">';
                                            html += '<img data-src="'+imgSrc+'" class="lazyload" alt="">';

                                        for(var coroa=0; coroa<album_image[ai].translations.length;coroa++){
                                            var translation = album_image[ai].translations[coroa];
                                            if(translation.locale == current_locale_code){
                                           
                                             if(translation.alternative_text != null ){
                                              html += '<span class="image-caption">'+translation.alternative_text+'</span>';
                                            }
                                              
                                            }
                                            
                                          }
                                        
                                           
                                        html += '</div>';
                                      }
                                      html += '</div>';
                                      
                                      html += '<div class="news-thumbnail slider-nav">';
                                      
                                      for(var ai = 0; ai < album_image.length; ai++){
                                        var imgSrc = '';
                                        
                                        if(album_image[ai].optimizedImage != null){
                                          imgSrc = album_image[ai].optimizedImage;
                                        }else{
                                          imgSrc = album_image[ai].url;
                                        }
                                        html += '<div class="news-thumbnail-images">';
                                            html += '<img data-src="'+imgSrc+'" class="lazyload" alt="" width="150">';
                                        html += '</div>';
                                      }
                                      html += '</div>';
                                    
                                    html += '</div>';
                                    
                                  } // endif album

                                  if(contentType == 'COLLECTION'){
                                    cole++;
                                    html += '<div class="content-type-collection">';
                                     html += '<'+contentData.titleSize+'>';
                                     html += translation.title;
                                     html += '</'+contentData.titleSize+'>';
                                     
                                     if(translation.description != null){
                                         html += '<p>'+translation.description+'</p>';
                                     }
     
                                     var item = {};
                                     item['limit'] = contentData.nrOfProductsVisible;
    
                                    var shopData = contentData.collection.shopData;
                                    for(var sd = 0; sd < shopData.length; sd++){
                                     // console.log(contentData.collection.shopData[sd]);
                                      if(contentData.collection.shopData[sd].shopName == 'mediconsult-ch' ){
                                      //console.log(contentData.collection.shopData[sd].urlHandle);
                                     item['handle'] = contentData.collection.shopData[sd].urlHandle;
                                      }
                                    }
    
                                     collectionHandle.push(item);
      
                                     html += '<div class="product-container" id="product-wrapper-'+cole+'"></div>';
                                     html += '</div>';
                                   }
  

                                }
                              } // Translation code

                              if(contentType == 'DOCUMENT'){
                                html += '<div class="content-type-document">';
                                  if(contentData.translations[0].document != '' && contentData.translations[0].document != null){
                                      html += '<style>';
                                      html += '.row__'+(row+1)+' .content__'+(content+1)+' .document-button{ background-color:'+contentData.buttonBackgroundColor+';color:'+contentData.buttonTextColor+';border: 1px solid '+contentData.buttonBorderColor+';padding: 10px;     text-decoration: none;}';
                                      html += '.row__'+(row+1)+' .content__'+(content+1)+' .document-button:hover{ background-color:'+contentData.buttonHoverColor+';}';
                                      html += '</style>';
                                      if(contentData.isDocumentDisplayedAsButton == 1){
                                          var btnClass = 'document-button';
                                      }else {
                                          var btnClass = '';
                                      }
                                      html += '<a href="'+contentData.translations[0].document+'" class="'+btnClass+'">'+contentData.translations[0].title+'</a>';
                                  }
                                html += '</div>';
                              } // end if contentType DOCUMENT

                              
  
                              if(contentType == 'DIVIDER'){
                                html += '<div class="content-type-divider">';
                                  html += '<hr>';
                                html += '</div>';
                              } // end if contentType DIVIDER
  
                              
                               
                              
                              html += '</div>'; // end content
                              
                            } // end if contentData
                          } // end for content
                        } // end if content.length
                      } // end if contentContainer
                    html += '</div>'; // end content-column
                  } // end for column
                } // end if column.length
              html += '</div>'; // end content-row  
            } // end for rows
          } // end if rows.length
        }

        
        
        if(showcontentBuilder == 'false'){
          html += data.description;
        
        var img = data.optimizedImage;
        if(data.optimizedImage == null){
          img = data.image;
        }else if(data.image == null){
          img = '';
        }

        if(data.album != null ){
            html += '<div id="news-media-wrapper-1" class="news-media-wrapper">';
            
              var album_image = data.album.images;
              
              html += '<div class="news-slider slider-for">';
              
              if(album_image.length > 9){
                slidetoshow = 9;
              }
              
              for(var ai = 0; ai < album_image.length; ai++){
                var imgSrc = '';
                
                if(album_image[ai].optimizedImage != null){
                  imgSrc = album_image[ai].optimizedImage;
                }else{
                  imgSrc = album_image[ai].url;
                }
                
                html += '<div class="news-images">';
                    html += '<img data-src="'+imgSrc+'" class="lazyload" alt="">';
                    if(album_image[ai].translations[0].caption != null ){
                      html += '<span class="image-caption">'+album_image[ai].translations[0].caption+'</span>';
                    }
                html += '</div>';
              }
              html += '</div>';
              
              html += '<div class="news-thumbnail slider-nav">';
              
              for(var ai = 0; ai < album_image.length; ai++){
                var imgSrc = '';
                
                if(album_image[ai].optimizedImage != null){
                  imgSrc = album_image[ai].optimizedImage;
                }else{
                  imgSrc = album_image[ai].url;
                }
                html += '<div class="news-thumbnail-images">';
                    html += '<img data-src="'+imgSrc+'" class="lazyload" alt="" width="150">';
                html += '</div>';
              }
              html += '</div>';
            
            html += '</div>';

        }
            }
         
        html += '</div>';
      html += '</div>';
      html += '</div>';

        $('#news-details-container').html(html);
      
        $('.preloading').remove();

        ajaxComplete = true;
        
      //});



    setTimeout(function() {
    
      slickCarousel();
      function slickCarousel() {
        $('.slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinate: true,
          arrows: true,
          asNavFor: '.slider-nav',
          adaptiveHeight: true,
           prevArrow:'<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Prev" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="left"><path d="M4.409 11l9.061-9.061 2.121 2.121-6.939 6.939 6.939 6.939-2.121 2.121z" fill="#fff"></path></svg></button>',
        nextArrow:'<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="right"><path d="M8.53 20.061l-2.121-2.121 6.939-6.939-6.939-6.939 2.121-2.121 9.061 9.061z" fill="#fff"></path></svg></button>'
        });
        $('.slider-nav').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
          centerMode: false,
          focusOnSelect: true,
          infinate: true,
          responsive: [
            {
                breakpoint: 767,
                settings: {
                  slidesToShow: 4,
                }
            }, 
            {
                breakpoint: 540,
                settings: {
                  slidesToShow: 2,
                }
            }
          ]
        });
      }
    
   }, 500);
      
         
      
    }
    else
    {
      
      html += '<div class="clearfix equal-columns--clear equal-columns--outside-trim product-list">';
      
      for(var a=0; a<totalData; a++){
        
        var json_response = response.data[a].attributes;
        var imagesrc = '';
        var title = jQuery.trim(json_response.name);
        var description = '';

        if(json_response.excerpt != null){
          description = json_response.excerpt;
        }else {
          description = '';
        }          
       
        if(json_response.optimizedListImage != null){
          imagesrc = json_response.optimizedListImage;
        }else if(json_response.optimizedImage != null){
          imagesrc = json_response.optimizedImage;
        }else if(json_response.image != null){
          imagesrc = json_response.image;
        }else if(json_response.headlineImage != null){
          imagesrc = json_response.headlineImage;
        }else{
          imagesrc = 'https://cdn.shopify.com/s/files/1/0548/8889/0619/files/MC_Logo_410x.png';
        }

        var focusXPercentage = "";
        if(json_response.focusXPercentage != null){
          focusXPercentage = json_response.focusXPercentage+'%';
        }else {
          focusXPercentage = 'top';
        }
  
        var focusYPercentage = "";
        if(json_response.focusYPercentage != null){
          focusYPercentage = json_response.focusYPercentage+'%';
        }else {
          focusYPercentage = 'center';
        }
        
        var newscat = '';
        if(json_response.newsCategory !== null ){

          for(var nc=0; nc <json_response.newsCategory.translations.length; nc++){
              newscat += ' '+json_response.newsCategory.translations[nc].webName;
          }
        }
        
        var url=response.data[a].id;
        if(response.data[a].attributes.urlHandle != null){
          var url = response.data[a].attributes.urlHandle;
        }      

        /*var translations = response.data[a].attributes.translations;
        if(translations.length>0){
          for(var t=0;t<translations.length;t++){
            var translation = translations[t];
            console.log(translation);
            if(translation.locale == current_locale_code ){
              
              title = jQuery.trim(translation.name);
              if(translation.excerpt != null){
                description = translation.excerpt;
              }else {
                description = '';
              }
            }
          }
        }

        if(json_response.optimizedListImage != null){
          imagesrc = json_response.optimizedListImage;
        }else if(json_response.optimizedImage != null){
          imagesrc = json_response.optimizedImage;
        }else if(json_response.image != null){
          imagesrc = json_response.image;
        }else if(json_response.headlineImage != null){
          imagesrc = json_response.headlineImage;
        }else{
          imagesrc = 'https://cdn.shopify.com/s/files/1/0548/8889/0619/files/MC_Logo_410x.png';
        }*/
            
          html += '<div class="one-third column medium-down--one-half small-down--one-half thumbnail even'+newscat+'">';
              html += '<div class="news-wrapper">';
                  html += '<div class="image-wrapper">';
                      html += '<img data-src="'+imagesrc+'" width="320" class="lazyload" loading="lazy" style="object-position: '+focusXPercentage+' '+focusYPercentage+'">';
                  html += '</div>';
                  html += '<div class="content-wrapper">';
                      html += '<div class="newsblock__date">'+formatDateString(response.data[a].attributes.publishDate,'regular','false')+'</div>';
                      html += '<h3 class="newsblock__title">'+title+'</h3>';
                      html += '<div class="newsblock__details">'+description+'</div>';
                  html += '</div>';
                  html += '<div class="link-wrapper">';
                      html +='<a href="'+site_url+'/pages/news/'+url+'" class="block-btn">';
                          html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 64C256 46.33 270.3 32 288 32H415.1C415.1 32 415.1 32 415.1 32C420.3 32 424.5 32.86 428.2 34.43C431.1 35.98 435.5 38.27 438.6 41.3C438.6 41.35 438.6 41.4 438.7 41.44C444.9 47.66 447.1 55.78 448 63.9C448 63.94 448 63.97 448 64V192C448 209.7 433.7 224 416 224C398.3 224 384 209.7 384 192V141.3L214.6 310.6C202.1 323.1 181.9 323.1 169.4 310.6C156.9 298.1 156.9 277.9 169.4 265.4L338.7 96H288C270.3 96 256 81.67 256 64V64zM0 128C0 92.65 28.65 64 64 64H160C177.7 64 192 78.33 192 96C192 113.7 177.7 128 160 128H64V416H352V320C352 302.3 366.3 288 384 288C401.7 288 416 302.3 416 320V416C416 451.3 387.3 480 352 480H64C28.65 480 0 451.3 0 416V128z"></path></svg>';
                      html += '</a>';
                  html += '</div>';
              html += '</div>';
          html += '</div>';
            
      }
      
      if(totalData == 0){
        html +='<p class="empty-category-text">Für diese Kategorie sind keine Nachrichten verfügbar.</p>';
        
      } 
      html +='</div>';
      
      // $('#news-container').html(html);
      $('.preloading').remove();
    }
    
    if(flag == 0){

      var pagi = '';

      var currentPage = response.meta.page.currentPage;
      var from = response.meta.page.from;
      var lastPage = response.meta.page.lastPage;
      var perPage = response.meta.page.perPage;
      var to = response.meta.page.to;
      var $pages = response.meta.page.total;
      var $num_links = 3;

      var $start = ((currentPage - $num_links) > 0) ? (currentPage - ($num_links - 1)) : 1;
      var $end   = ((currentPage + $num_links) < lastPage) ? (currentPage + $num_links) : lastPage;
      
      if(getParameterByName('category') == null){
        if(getParameterByName('player') != null){
          var pg = '?player='+getParameterByName('player')+'&page=';
        }else{
          var pg = '?page=';
        }
        
      }else{
        var pg = '?category='+getParameterByName('category')+'&page=';
      }

      if(lastPage > 1){    

        if(currentPage == 1) {
          classNm="disabled";
          var pageLink = site_url+'/pages/'+newsPageHandle+pg;
        }else{
          classNm = '';
          var pageLink = site_url+'/pages/'+newsPageHandle+pg+(currentPage-1);
        }
          pagi += '<li class="pagination__item_wrapper previ-link '+classNm+'">';
          pagi += '<a href="'+pageLink+'" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce">';
          pagi += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path> </svg>';
          pagi += '</a>';
          pagi += '</li>';

        if(currentPage > 3 ){
          pagi += '<li class="pagination__item_wrapper"><a href="'+site_url+'/pages/'+newsPageHandle+pg+'1" class="pagination__item link">1</a></li>';
          if(lastPage>5){
            pagi += '<li class="pagination__item_wrapper"><span class="pagination__item">...</span></li>';
          }
        }
        for(var $x=$start ; $x<$end ;$x++)
        {
          pagi += '<li class="pagination__item_wrapper">';

          if($x == currentPage)
          {
            pagi += '<span class="pagination__item pagination__item--current" aria-current="page" >'+$x+'</span>';
          }
          else
          {
            pagi += '<a href="'+site_url+'/pages/'+newsPageHandle+pg+$x+'" class="pagination__item link">'+$x+'</a>';
          }
          pagi += '</li>';

        }
        if(currentPage <= lastPage){
          if(lastPage>5){
            pagi += '<li class="pagination__item_wrapper"><span class="pagination__item">...</span></li>';
          }
          if(currentPage == lastPage ){
            pagi += '<li class="pagination__item_wrapper"><span class="pagination__item pagination__item--current" aria-current="page" >'+lastPage+'</span></li>';
          }else{
            pagi += '<li class="pagination__item_wrapper"><a href="'+site_url+'/pages/'+newsPageHandle+pg+lastPage+'" class="pagination__item link">'+lastPage+'</a></li>';
          }
        }

        if(currentPage == lastPage ){
          classNm="disabled";
          var pageLink = '#';
        }else{
          classNm = '';
          var pageLink = site_url+'/pages/'+newsPageHandle+pg+(parseInt(currentPage)+1);          
        }
          pagi += '<li class="pagination__item_wrapper last-link '+classNm+'">';
          pagi += '<a href="'+pageLink+'" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce">';
          pagi += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path> </svg>';
          pagi += '</a>';
          pagi += '</li>';
      }

      $('#news-pagination .pagination__list').html(pagi);
    }

    
    
  });
  
 
 /* function slickCarousel() {
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinate: true,
      arrows: true,
      asNavFor: '.slider-nav',
      adaptiveHeight: true
    });
    $('.slider-nav').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      centerMode: true,
      focusOnSelect: true,
      infinate: true,
      responsive: [
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 7,
            }
        },
        {
            breakpoint: 540,
            settings: {
              slidesToShow: 5,
            }
        }
      ]
    });

    $('.slick-aufstellung').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      prevArrow:'<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Prev" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="left"><path d="M4.409 11l9.061-9.061 2.121 2.121-6.939 6.939 6.939 6.939-2.121 2.121z" fill="#fff"></path></svg><span>Ersatzbank</span></button>',
      nextArrow:'<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="right"><path d="M8.53 20.061l-2.121-2.121 6.939-6.939-6.939-6.939 2.121-2.121 9.061 9.061z" fill="#fff"></path></svg><span>Ersatzbank</span></button>'
    });
    
    $('.slick-aufstellung').slick('slickGoTo', 1);

    $('.slick-aufstellung-mobile').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
    });

    
    
  }
  
  function destroyCarousel() {
    if ($('.slider-for').hasClass('slick-initialized')) {
      $('.slider-for').slick('destroy');
    }
    if ($('.slider-nav').hasClass('slick-initialized')) {
      $('.slider-nav').slick('destroy');
    }

    if ($('.slick-aufstellung').hasClass('slick-initialized')) {
      $('.slick-aufstellung').slick('destroy');
    }

    if ($('.slick-aufstellung-mobile').hasClass('slick-initialized')) {
      $('.slick-aufstellung-mobile').slick('destroy');
    }

    
  }*/


  
});

// News Categories      
var settings = {
  "url": "/a/api-request/aico/theme/news-categories?page[number]=1&page[size]=10&sort=sortingNumber",
  "method": "GET",
  "timeout": 0,
  "headers": {
    "Authorization": Authorization,
    "Accept": "application/vnd.api+json"
  },
};

$.ajax(settings).done(function (response) {

  
  var totalData = response.data.length;

  var html='';
  
  
  for(var a=0 ; a < totalData ; a++){

    //console.log(response.data);
    
    var active = '';
    if(getParameterByName('category') != null){
      var current_cat = getParameterByName('category');
    }else{
      var current_cat = '';
    }
    if(current_cat == response.data[a].attributes.translations[0].id){
      var active = 'active';
    }else{
      var active = '';
    }
    
    if(response.data[a].attributes.isActive==1){
      html += '<button class="btn '+active+'" data-id="'+response.data[a].attributes.translations[0].webName+'" data-catid="'+response.data[a].attributes.translations[0].id+'" >'+response.data[a].attributes.translations[0].webName+'</button>';
    }
  }
  if(current_cat == ''){
    var active = 'active';
  }else{
    var active = '';
  }
 
  if(current_locale_code == 'de_CH' || current_locale_code == 'de'){
    html += '<button class="btn '+active+'" data-id="*">Alle Artikel</button>';
  }
  if(current_locale_code == 'fr'){
    html += '<button class="btn '+active+'" data-id="*">Tous les articles</button>';
  } 
  $('#filter-container').html(html);
});


//news filter
$(document).on('click','#filter-container .btn', function(){
  $(this).toggleClass('active');
  
  if($(this).hasClass('active')){
    var dataCat = $(this).data('catid');
    if(typeof dataCat !== 'undefined'){
        window.location.href=site_url+"/pages/news?category="+dataCat;
    }else{
      window.location.href=site_url+"/pages/news";
    }
  }else{
    window.location.href=site_url+"/pages/news";
  }
  
});


const setinterval = setInterval(function(){
  if(ajaxComplete == true){
    if($('.product-container').length > 0){
    
      for(var a = 0; a<collectionHandle.length; a++){
        var cHandle = collectionHandle[a].handle;
        var limit = collectionHandle[a].limit;
        //console.log(cHandle);
        var cc = 1;
        $.getJSON('/collections/'+cHandle+'/products.json?limit='+limit, function(response) {
          var proHtml = '';
          
          var collproducts = response.products;
          var proImage;
          var proTitle;
          
          // console.log(limit);
          if(limit>4){
            var dynamicClass = 'slider-for-news owl-carousel product-list collection-matrix clearfix equal-columns--clear equal-columns--outside-trim';
          } else {
            var dynamicClass = 'product-list collection-matrix clearfix equal-columns--clear equal-columns--outside-trim';
          }
          if(collproducts.length > 0){
            proHtml += '<div class="'+dynamicClass+'">';
            for(var colpro = 0; colpro < collproducts.length; colpro++ ){
              proHtml += '<div class="custom-class-slider one-fourth column medium-down--one-half small-down--one-whole thumbnail even">';
                //console.log(collproducts[colpro]);
                var proTitle = collproducts[colpro].title;
                var proUrl = '/products/'+collproducts[colpro].handle;
                proHtml += '<div class="product-wrap">';
                  var proImage = collproducts[colpro].images[0].src;
                  proHtml += '<div class="news-thumbnail-images">';
                    proHtml += '<a href="'+proUrl+'">';
                    proHtml += '<img src="'+proImage+'" class="lazyload" alt="" width="150">';
                    proHtml += '</a>';
                  proHtml += '</div>';
                proHtml += '</div>';
                proHtml += '<a class="product-info__caption  gsvalidated" href="'+proUrl+'"><div class="product-details"><span class="title">'+proTitle+'</span></div></a>';
              proHtml += '</div>';
            }
            proHtml += '</div>';
          }

          $('#product-wrapper-'+cc+'.product-container').html(proHtml);
          cc++;
        });

      }
    }


    destroySlickslider();
      setTimeout(function(){
       initSlickslider();
     },1000);
   clearInterval(setinterval);
  }
  
},1000);

  initSlickslider();
  function initSlickslider() {
      $('.product-container .slider-for-news').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinate: false,
        arrows: true,
        prevArrow:'<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Prev" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="left"><path d="M4.409 11l9.061-9.061 2.121 2.121-6.939 6.939 6.939 6.939-2.121 2.121z" fill="#fff"></path></svg></button>',
        nextArrow:'<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="right"><path d="M8.53 20.061l-2.121-2.121 6.939-6.939-6.939-6.939 2.121-2.121 9.061 9.061z" fill="#fff"></path></svg></button>',
        responsive: [
          {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
              }
          },
          {
              breakpoint: 540,
              settings: {
                slidesToShow: 2,
              }
          }
        ]
      })
  }
  destroySlickslider();
  function destroySlickslider() {
    if ($('.product-container .slider-for-news').hasClass('slick-initialized')) {
      $('.product-container .slider-for-news').slick('destroy');
    }
  }